import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Collapse, CollapseProps, Modal, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import LocationListItemDTO from 'src/models/generated/LocationListItemDTO';

export interface LocationsTableProps {
  data?: LocationListItemDTO[];
  loading?: boolean;
}

const LocationsTable: React.FC<LocationsTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const showModal = (record: LocationListItemDTO) => {
    Modal.info({
      icon: null,
      content: <div dangerouslySetInnerHTML={{__html: record.details}}></div>
    });
  };

  const tableColumns: ColumnProps<LocationListItemDTO>[] = [
    TableColumnBuilder.Create<LocationListItemDTO>('locationName', 'Location Name')
      .Width(300)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Typography', { copyable: true, ellipsis: true })
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('code', 'Code')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('comment', 'Comment')
      // .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('pos', 'POS')
      .Width(80)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('sms', 'SMS')
      .Width(80)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('exportSystem', 'Export System')
      .Width(150)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('tenant', 'Tenant')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('appEnabled', 'App Enabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('disabled', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LocationListItemDTO>('details', '')
      .Width(125)
      .AddRenderer('Custom', (value, record) => <Button type='link' onClick={() => showModal(record)}>View Details</Button>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='locations-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Locations</h3>}>
        <Table
          rowKey={NameOf<LocationListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default LocationsTable;
